<!--pallet surface area-->
<mat-card class="mat-elevation-z">
  <mat-card-header>
    <mat-card-title>Pallet Dimensions</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div *ngIf="this.item680Validations.getPalletSurfaces().length > 0">
      <mat-list>
        <mat-list-item *ngFor="let surface of this.item680Validations.getPalletSurfaces(); let i = index">
          <div class="form-surface">
            <mat-form-field>
              <input
                matInput
                placeholder="Pieces"
                (change)="handlePalletChange()"
                [(ngModel)]="surface.pieces"
                inputNumber
                [acceptDecimalPlaces]="false"
                appNumberFormat
                inputmode="numeric"
                pattern="[0-9\-]*"
              />
            </mat-form-field>
            <mat-form-field>
              <input
                matInput
                placeholder="Length"
                (change)="handlePalletChange()"
                [(ngModel)]="surface.length"
                inputNumber
                [acceptDecimalPlaces]="true"
                [decimalPlaces]="1"
                appNumberFormat
                inputmode="numeric"
                pattern="[0-9\-].+"
              />
            </mat-form-field>
            <mat-form-field>
              <input
                matInput
                placeholder="Width"
                (change)="handlePalletChange()"
                [(ngModel)]="surface.width"
                inputNumber
                [acceptDecimalPlaces]="true"
                [decimalPlaces]="1"
                appNumberFormat
                inputmode="numeric"
                ppattern="[0-9\-].+"
              />
            </mat-form-field>
          </div>
          <div *ngIf="palletErrors[i]" class="mat-error">{{ palletErrors[i] }}</div>
        </mat-list-item>
      </mat-list>
    </div>
  </mat-card-content>
  <mat-card-actions> </mat-card-actions>
</mat-card>
